module.exports = __webpack_public_path__ + "static/media/galerija_2016 (12).87c675dd.jpg";